// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/index.js'
import vueAwesomeSwiper from 'vue-awesome-swiper'
import wx from 'weixin-js-sdk'
import axios from 'axios'
import 'jquery'
// import './css/index.scss'
import './css/animate.css'
import 'swiper/dist/css/swiper.css'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

//
// if (
//   '-ms-scroll-limit' in document.documentElement.style &&
//   '-ms-ime-align' in document.documentElement.style
// ) { // detect it's IE11
//   window.addEventListener("hashchange", function(event) {
//     console.log('op')
//     var currentPath = window.location.hash.slice(1);
//     if (store.state.route.path !== currentPath) {
//       router.push(currentPath)
//     }
//   }, false)
// }

Vue.config.productionTip = false



import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;

	}
	if (to.path == '/NewDetail') {
		if (store.state.article) {
			next()
		} else {
			next({
				path: '/News',
			})
		}

	} else {
		next()
	}
});



/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	vueAwesomeSwiper,
	components: { App },
	template: '<App/>',
	mounted() {
		document.dispatchEvent(new Event('render-event'))
	}
})



// WEBPACK FOOTER //
// ./src/main.js